module.exports = __webpack_public_path__ + "media/images/athletes/512-9a589fc7bb13452d350ee8276675d372.png";